import React, { useState, useEffect } from "react";
import { ProgramContext } from "./context";
import { programService } from "../../services/program.service";
import { ProgramDetails } from "../../services/program.service";

export function ProgramProvider({ children }: { children: React.ReactNode }) {
  const [activePrograms, setActivePrograms] = useState<ProgramDetails[]>([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const fetchPrograms = async () => {
    try {
      setIsLoading(true);
      setError(null);
      const [active] = await Promise.all([programService.findActivePrograms()]);
      setActivePrograms(active);
    } catch {
      setError("Failed to load programs");
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchPrograms();
  }, []);

  return (
    <ProgramContext.Provider
      value={{
        activePrograms,
        isLoading,
        error,
        fetchPrograms: fetchPrograms,
      }}
    >
      {children}
    </ProgramContext.Provider>
  );
}
